// Workspace query/mutation hooks. GET/POST /v1/workspaces (workspaces.rs).

import { queryOptions, useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { http } from "./http";
import { workspaceKeys } from "./keys";
import type { CreateWorkspace, Workspace } from "./types";

// Shared between the hook and the route loaders (Task 3): `/` and
// `/w/$workspaceId`'s beforeLoad call `queryClient.ensureQueryData` on this
// exact options object so the boot redirect and the URL-validation guard
// read the same cache entry the hook does.
export const workspacesQueryOptions = queryOptions({
    queryKey: workspaceKeys.all,
    queryFn: () => http.get<Workspace[]>("/v1/workspaces"),
});

export function useWorkspaces() {
    return useQuery(workspacesQueryOptions);
}

export function useCreateWorkspace() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (body: CreateWorkspace) => http.post<Workspace>("/v1/workspaces", { json: body }),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: workspaceKeys.all });
            // Org grants (canCreateWorkspace) and the selector's workspace
            // list both live on the identity — a fresh workspace can change
            // what it shows.
            queryClient.invalidateQueries({ queryKey: ["me"] });
        },
    });
}
